import React from "react";
import { Image, Modal } from "antd";
import { Col, Row, Tab, Tabs, Image as ImagePlaceholder } from "react-bootstrap";
import placeholderFrontImage from "../../styles/Assets/placeholderFrontImage.png";
import placeholderBackImage from "../../styles/Assets/placeholderBackImage.png";
import placeholderSideImage from "../../styles/Assets/placeholderSideImage.png";

const ProgressPicturesModal = ({
  visible,
  onClose,
  activeTab,
  setActiveTab,
  clientCheckInData,
}) => {
  const handleSelect = (key) => {
    setActiveTab(key);
  };

  // Helper function to check if image URL is available
  const hasImageUrl = (imageObj) => {
    return imageObj?.url && imageObj.url.trim() !== "";
  };

  return (
    <Modal
      title="Progress Pictures"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Tabs
        activeKey={activeTab}
        onSelect={handleSelect}
        id="controlled-tab-example"
        className="progress-pictures-tabs mb-3"
      >
        <Tab
          eventKey="front"
          title={
            <div
              className={`progress-pictures_tab-title ${
                activeTab === "front" ? "active" : ""
              }`}
            >
              Front
            </div>
          }
        >
          {activeTab === "front" && (
            <Row>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.firstCheckInFrontImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.firstCheckInFrontImage?.url}`}
                    alt="First check in's front image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderFrontImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderFrontImage}
                    alt="First check in's front image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  First Check-in
                </p>
              </Col>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.previousCheckInFrontImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.previousCheckInFrontImage?.url}`}
                    alt="Previous check in's front image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderFrontImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderFrontImage}
                    alt="Previous check in's front image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  Previous Check-in
                </p>
              </Col>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.latestCheckInFrontImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.latestCheckInFrontImage?.url}`}
                    alt="Latest check in's front image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderFrontImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderFrontImage}
                    alt="Latest check in's front image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  Recent Check-in
                </p>
              </Col>
            </Row>
          )}
        </Tab>
        <Tab
          eventKey="side"
          title={
            <div
              className={`progress-pictures_tab-title ${
                activeTab === "side" ? "active" : ""
              }`}
            >
              Side
            </div>
          }
        >
          {activeTab === "side" && (
            <Row>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.firstCheckInSideImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.firstCheckInSideImage?.url}`}
                    alt="First Check in's side image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderSideImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderSideImage}
                    alt="First Check in's side image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  First Check-in
                </p>
              </Col>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.previousCheckInSideImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.previousCheckInSideImage?.url}`}
                    alt="Previous check in's side image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderSideImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderSideImage}
                    alt="Previous check in's side image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  Previous Check-in
                </p>
              </Col>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.latestCheckInSideImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.latestCheckInSideImage?.url}`}
                    alt="Latest check in's side image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderSideImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderSideImage}
                    alt="Latest check in's side image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  Recent Check-in
                </p>
              </Col>
            </Row>
          )}
        </Tab>
        <Tab
          eventKey="back"
          title={
            <div
              className={`progress-pictures_tab-title ${
                activeTab === "back" ? "active" : ""
              }`}
            >
              Back
            </div>
          }
        >
          {activeTab === "back" && (
            <Row>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.firstCheckInBackImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.firstCheckInBackImage?.url}`}
                    alt="First check in's back image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderBackImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderBackImage}
                    alt="First check in's back image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  First Check-in
                </p>
              </Col>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.previousCheckInBackImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.previousCheckInBackImage?.url}`}
                    alt="Previous check in's back image"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderBackImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderBackImage}
                    alt="Previous check in's back image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  Previous Check-in
                </p>
              </Col>
              <Col>
                {hasImageUrl(
                  clientCheckInData?.progressPictures?.latestCheckInBackImage,
                ) ? (
                  <Image
                    src={`${clientCheckInData?.progressPictures?.latestCheckInBackImage?.url}`}
                    alt="Back"
                    className="client-modal-progress-pictures-images"
                    onError={(e) => (e.target.src = placeholderBackImage)}
                  />
                ) : (
                  <ImagePlaceholder
                    src={placeholderBackImage}
                    alt="Latest check in's back image placeholder"
                    className="client-modal-progress-pictures-images"
                  />
                )}
                <p className="fs-6 font-bold d-flex mt-1 justify-content-center">
                  Recent Check-in
                </p>
              </Col>
            </Row>
          )}
        </Tab>
      </Tabs>
    </Modal>
  );
};

export default ProgressPicturesModal;